"use client";

import { c as _c } from "react/compiler-runtime";
import { threadsControllerFindOneQueryKey } from "@dc/gateway-jsonapi";
import { isRecord } from "@dc/utils";
import { useQueryClient } from "@tanstack/react-query";
import type { Message } from "ably";
import { useChannel } from "ably/react";
import type { FC } from "react";
import { THREADS_INFINITE_KEY } from "@/components/CrunchAIChat/hooks/useThreadsInfinite/useThreadsInfinite";
import { EVENT_THREAD_NAMED } from "@/constants/Ably/events";
import { isUsableUserChannelName } from "@/lib/ablyChannels";
import { useUserChannel } from "../UserChannelProvider";
const isThreadNamedData = (value: unknown): value is {
  threadId: string;
} => isRecord(value) && typeof value.threadId === "string";
const ThreadNamedListener: FC<{
  channelName: string;
}> = t0 => {
  const $ = _c(4);
  const {
    channelName
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== channelName) {
    t1 = {
      channelName
    };
    $[0] = channelName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== queryClient) {
    t2 = message => {
      if (!isThreadNamedData(message.data)) {
        return;
      }
      queryClient.invalidateQueries({
        queryKey: threadsControllerFindOneQueryKey(message.data.threadId)
      });
      queryClient.invalidateQueries({
        queryKey: THREADS_INFINITE_KEY
      });
    };
    $[2] = queryClient;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useChannel(t1, EVENT_THREAD_NAMED, t2);
  return null;
};
export const ThreadNamedSubscriber = () => {
  const $ = _c(2);
  const {
    channelName
  } = useUserChannel();
  if (!isUsableUserChannelName(channelName)) {
    return null;
  }
  let t0;
  if ($[0] !== channelName) {
    t0 = <ThreadNamedListener channelName={channelName} />;
    $[0] = channelName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};